export default __webpack_public_path__ + "static/media/githubLight.d5634fd7.svg";